export const DEFAULT_SEGMENT_STYLING = {
  border: 'none',
  boxShadow: 'none',
  background: 'none',
};

export const DEFAULT_GRID_CLASS_NAME = 'custom-page-grid';
